/*
 * df-teeinblue-scroll-fix.js
 *
 * Resuelve el bug de scroll vertical bloqueado al tocar la foto de producto
 * que Teeinblue inyecta dentro de .product-converter__media en móvil.
 *
 * --- ESTRATEGIA ---
 * Forzar `touch-action: pan-y` como inline style con flag !important en los
 * elementos interactivos que Teeinblue añade dentro del wrapper de la galería:
 * <canvas>, <iframe>, y los <div> con clases tee-* (sobre todo
 * .tee-mockup-item, que es el contenedor 364x364 confirmado en el inspector).
 *
 * Inline-set con setProperty + 'important' gana frente a cualquier regla CSS
 * y frente a inline styles del SDK, por lo que el browser puede hacer pan
 * vertical nativo aunque Teeinblue intente capturar el touch.
 *
 * --- DIFERENCIA CON VERSIÓN ANTERIOR ---
 * La versión anterior procesaba cada elemento UNA SOLA VEZ. Si Teeinblue
 * re-escribía el style attribute después de nuestro fix, perdíamos. Esta
 * versión:
 *   1. Re-aplica sin gate (sin WeakSet de "ya procesados") — barato (setProperty)
 *   2. Observa childList + subtree + attributes:['style','class'] del wrapper
 *   3. Engancha al evento 'teeinblue-event-component-injected' para forzar
 *      una pasada completa cuando Teeinblue avisa de que terminó de inyectar
 *   4. Pasada de seguridad a los 1000ms y 3000ms (cubre carga lenta del SDK)
 *
 * --- POR QUÉ NO ROMPE NADA ---
 *  - NO monkey-patch de addEventListener
 *  - NO stopPropagation/stopImmediatePropagation de touch events
 *  - NO neutralización de setPointerCapture
 *  - `touch-action: pan-y` deja al browser hacer scroll vertical y deja pasar
 *    tap/click/horizontal-drag al JS de Teeinblue intacto, así que el swipe
 *    entre mockups (← →) y el customizer siguen funcionando.
 *
 * --- ALCANCE ---
 * Solo viewport móvil (matchMedia max-width: 990px). Solo dentro de
 * .product-converter__media. Cero side-effects fuera del PDP.
 */
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(max-width: 990px)').matches) {
    return;
  }

  var WRAPPER_SELECTOR = '.product-converter__media';
  var TARGETS_SELECTOR = [
    'canvas',
    'iframe',
    '.tee-mockup-item',
    '[class*="tee-mockup"]',
    '[class*="tee-gallery"]',
    '[class*="tee-slider"]'
  ].join(',');

  function applyPanY(el) {
    if (!el || el.nodeType !== 1 || !el.style) return;
    if (el.style.getPropertyValue('touch-action') === 'pan-y' &&
        el.style.getPropertyPriority('touch-action') === 'important') {
      return;
    }
    try {
      el.style.setProperty('touch-action', 'pan-y', 'important');
    } catch (e) { /* noop */ }
  }

  function processSubtree(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(TARGETS_SELECTOR)) applyPanY(root);
    if (root.querySelectorAll) {
      var inner = root.querySelectorAll(TARGETS_SELECTOR);
      for (var i = 0; i < inner.length; i++) applyPanY(inner[i]);
    }
  }

  function processAllContainers() {
    var containers = document.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < containers.length; i++) processSubtree(containers[i]);
  }

  function watchContainer(container) {
    processSubtree(container);
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) processSubtree(m.addedNodes[j]);
        } else if (m.type === 'attributes' && m.target) {
          if (m.target.matches && m.target.matches(TARGETS_SELECTOR)) applyPanY(m.target);
        }
      }
    });
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function init() {
    var containers = document.querySelectorAll(WRAPPER_SELECTOR);
    if (!containers.length) return;
    for (var i = 0; i < containers.length; i++) watchContainer(containers[i]);

    document.addEventListener('teeinblue-event-component-injected', processAllContainers);
    setTimeout(processAllContainers, 1000);
    setTimeout(processAllContainers, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
